"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newly = exports.compatible = exports.widely = void 0;
const compatible_1 = __importStar(require("./compatible"));
Object.defineProperty(exports, "compatible", { enumerable: true, get: function () { return compatible_1.compatible; } });
const newly_1 = __importStar(require("./newly"));
Object.defineProperty(exports, "newly", { enumerable: true, get: function () { return newly_1.newly; } });
const widely_1 = __importStar(require("./widely"));
Object.defineProperty(exports, "widely", { enumerable: true, get: function () { return widely_1.widely; } });
exports.default = {
    widely: widely_1.default,
    compatible: compatible_1.default,
    newly: newly_1.default,
};
//# sourceMappingURL=index.js.map